export enum Resolution {
    small = 'small',
    large = 'large',
}

// TODO: Why? We could do this with CSS only, no?

// TODO this does not respect the 'devicePixelRatio' -- should styles use 'rem' exclusively?
const getResolution = () => {
    if (window.innerWidth >= 1920 && window.innerHeight >= 1080) {
        return Resolution.large
    } else {
        return Resolution.small
    }
}

class ResolutionController {
    resolution: Resolution

    constructor() {
        this.resolution = getResolution()

        const isLarge = this.resolution === Resolution.large
        document.body.classList.add(isLarge ? 'large' : 'small')
        document.body.classList.remove(!isLarge ? 'large' : 'small')

        window.addEventListener('resize', () => this.update())
    }

    update = () => {
        this.resolution = getResolution()
        const isLarge = this.resolution === Resolution.large

        console.debug(
            `>>>>> Inamove::Resolution => using Resolution: ${isLarge ? 1920 : 1280} x ${isLarge ? 1080 : 720}`
        )

        document.body.classList.add(isLarge ? 'large' : 'small')
        document.body.classList.remove(!isLarge ? 'large' : 'small')
    }
}

export default new ResolutionController()
